import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import HeaderCarousel from "@/components/HeaderCarousel";
import JourneyMap from "@/components/JourneyMap"; // 1. Import komponen JourneyMap
import { ACTIVITIES, PAGE_HEADERS } from "@/data/site";
import { ArrowUpRight, ArrowRight, Compass } from "lucide-react";
import { Reveal } from "@/components/Reveal";

  // Define your roadmap milestones

export default function Activity() {

  const milestones = [
    {
      year: "2023",
      title: "The Foundation",
      description: "Michma was established with a core mission to improve health literacy in young hands.",
    },
    {
      year: "2024",
      title: "Expanding Outreach",
      description: "Launched regional educational programs across multiple schools and communities.",
    },
    {
      year: "2025",
      title: "Digital Transformation",
      description: "Introduced digital tools and resources to reach a wider nationwide audience.",
    },
    {
      year: "2026",
      title: "The Next Horizon",
      description: "Scaling our impact with sustainable loops and stronger community partnerships.",
    },
  ];
  
  return (
    <div data-testid="activity-page" className="bg-slate-50/50 min-h-screen">
      <HeaderCarousel testid="activity-header" {...PAGE_HEADERS.activity} />

      {/*<section className="max-w-4xl mx-auto px-6 py-24">
      <div className="text-center mb-16">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-michma mb-3">
          Our History
        </p>
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-michma-ink">
          The Journey Roadmap
        </h2>
      </div>

      // Timeline container
      <div className="relative border-l-2 border-michma/20 ml-4 md:ml-32 space-y-12">
        {milestones.map((item, index) => (
          <Reveal key={item.year} delay={index * 0.1}>
            <div className="relative pl-8 md:pl-12">
              // Timeline Dot
              <div className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-michma border-4 border-white shadow-sm" />

              // Year Label (Positioned nicely on larger screens)
              <span className="md:absolute md:-left-32 md:top-1 font-mono text-sm font-bold text-michma block mb-1 md:mb-0">
                {item.year}
              </span>

              // Content Card
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm hover:border-michma transition-colors">
                <h3 className="font-heading font-bold text-xl text-michma-ink mb-2">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>*/}

    {/*Journey Roadmap Section
    <div>
      <JourneyMap />
    </div> */}

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-28 md:pb-36">
        
        {/* ================= QUICK ACTIVITIES NAVIGATION ================= */}
        <div className="mb-16">
          <div className="flex items-center justify-center gap-2 mb-6 text-xs font-mono uppercase tracking-[0.2em] text-slate-500 font-bold">
            <Compass className="w-4 h-4 text-michma" /> Quick Navigation
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 max-w-5xl mx-auto">
            {ACTIVITIES.map((activity) => (
              <Link
                key={activity.slug}
                to={`/activity/${activity.slug}`}
                className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white border border-slate-200/90 text-slate-700 hover:border-michma hover:text-michma hover:bg-michma-soft/50 font-mono text-xs font-bold transition-all duration-200 shadow-xs hover:scale-105"
              >
                <span>{activity.title}</span>
                <ArrowRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-michma transition-transform group-hover:translate-x-0.5" />
              </Link>
            ))}
          </div>
        </div>

        {/* ================= ACTIVITIES GRID ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ACTIVITIES.map((p, i) => (
            <motion.div
              key={p.slug || p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
              className={i === 0 ? "md:col-span-2 md:row-span-1" : ""}
            >
              <article
                data-testid={`program-card-${i}`}
                className="group h-full rounded-3xl border border-slate-200 overflow-hidden bg-white hover:border-michma hover:shadow-lg transition-all duration-300 flex flex-col justify-between"
              >
                <div>
                  {/* Image Link */}
                  <Link
                    to={`/activity/${p.slug}`}
                    className="block overflow-hidden relative"
                  >
                    <div className={i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}>
                      <img
                        src={p.image}
                        alt={p.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                  </Link>

                  {/* Content */}
                  <div className="p-8">
                    <div className="flex items-center justify-between mb-3">
                      <span className="font-mono text-xs uppercase tracking-[0.2em] text-michma font-extrabold px-3 py-1 rounded-full bg-michma-soft border border-michma/20">
                        {p.tag}
                      </span>
                      {p.link && (
                        <a
                          href={p.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid={`program-link-${i}`}
                          className="inline-flex items-center gap-1 text-xs font-semibold text-michma hover:text-michma-hover"
                        >
                          Visit <ArrowUpRight className="w-3.5 h-3.5" />
                        </a>
                      )}
                    </div>

                    <h3 className="font-heading font-bold text-2xl tracking-tight text-michma-ink group-hover:text-michma transition-colors">
                      <Link to={`/activity/${p.slug}`}>{p.title}</Link>
                    </h3>

                    <p className="mt-3 text-slate-600 leading-relaxed text-sm">
                      {p.body}
                    </p>
                  </div>
                </div>

                {/* Card Bottom Link */}
                <div className="px-8 pb-8 pt-0">
                  <Link
                    to={`/activity/${p.slug}`}
                    className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider font-extrabold text-michma group-hover:translate-x-1 transition-transform"
                  >
                    Explore Initiative <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </article>
            </motion.div>
          ))}
        </div>
      </section>

    </div>
  );
}